import React from 'react';
import "./Navbar.css";
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";

export const Navbar = () => {
  const { user, registered } = useAuth();

  return (
    <nav className='navegador-principal'>
      <Link to="/"><h2>eRastro</h2></Link>
      <ul>
        {user && registered ? (
          <>
            <li><Link to="/usuario">Mi perfil</Link></li>
            <li><Link to="/nosotros">Nosotros</Link></li>
          </>
        ) : (
          <>
            <li><Link to="/login">Iniciar sesión</Link></li>
            <li><Link to="/nosotros">Nosotros</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
};
